<div class="item-holder" (click)="viewListingDetails($event)"
  [ngClass]="{'unpaired' : listing.pairedStatus === 'unpaired'}" *ngIf="loaded">

  <div *ngIf="loaded">
    <div class="listing-image-wrapper">

      <ion-img class="user-image" *ngIf="hasPropertyImage" [src]="propertyImage"
        [alt]="listing.address.title"></ion-img>
      <ion-img class="user-image" [src]="listing.address.title | mapUrl" [alt]="listing.address.title"
        *ngIf="listing.address.placeId && !hasPropertyImage"></ion-img>
      <app-text-avatar *ngIf="!listing.hasPropertyImage && !listing.address.placeId" [avatarName]="listing.avatarName"
        [avatarColor]="listing.color"></app-text-avatar>
    </div>
  </div>

  <div class="listing-body" #listingBody>
    <div class="listing-title link">
      <span [attr.data-cy]="'myPairedListings-listingItem-title'">
        {{listing.address.title}}</span>
    </div>

    <div class="agent-wrapper">

      <!-- <div class="agent-wrapper-inner-container">
        <ion-img class="user-image" [src]="agentImage" *ngIf="agentImage" [alt]="listingAgent.username"></ion-img>
        <app-profile-image-item *ngIf="!agentImage" class="agentAvatar" [profile]="listingAgent">
        </app-profile-image-item>

        <div class="agent-sub link" (click)="viewListingDetails($event)" *ngIf="listingAgent">
          <div class="agent-title">
            {{listingAgent?.username || '--'}}
          </div>
          <div class="agent-company">
            {{listingAgent?.company || '--'}}
          </div>
        </div>

        <div *ngIf="listing?.guests && listing.guests?.length > 0" class="vertical-divider"></div>
      </div> -->

      <div class="agent-wrapper-inner-container">
        <div *ngIf="listing?.guests && listing.guests?.length > 0" class="listing-guests">
          <div class="guests-items" *ngIf="listing && listing.guests && listing.guests.length > 0" tappable
            (click)="goToMyGuests($event)">
            <div *ngFor="let guest of listing.guests; let index = index" class="avatar-holder"
              [class.hidden]="index>=maxGuestCount">
              <app-guest-item *ngIf="!guest.archived" [guest]="guest"></app-guest-item>
            </div>
            <div class="more-avatar-holder">
              <span class="more-avatar" [style.background-color]="countColor"
                [style.font-size.px]="listing.guests.length - maxGuestCount > 99 ? '10' : '13'"
                *ngIf="listing.guests.length > maxGuestCount">
                +{{listing.guests.length - maxGuestCount}}
              </span>
            </div>
          </div>
          <div class="no-guests" *ngIf="listing && (!listing.guests || listing.guests && listing.guests.length === 0)">
            <div class="icon-wrapper">
              <ion-icon ios="ios-close" md="close-outline" [style.color]="'white'"></ion-icon>
            </div>
            <span>No leads</span>
          </div>

        </div>
        <div class="verticalSpace" *ngIf="!listing?.guests || listing.guests?.length === 0">

        </div>
      </div>

    </div>

    <div *ngIf="loaded" class="listing-date"
      [attr.data-cy]="'pairedListing-' + listing.address.title + '-creationDate'">
      Added {{listing.createdAt | momentFormat:'MM-DD-YY'}} by {{addedByUserText}}
    </div>

  </div>


  <!-- SHARE ICONS DESKTOP-->
  <div class="listingShareIcons pc-lnk">

    <ion-button 
      (click)="saveQR($event)"
      [class.faded]="!listing.webPublished"
      size="small"
      fill="clear"
    >
      <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="qr-code-outline"></ion-icon>
    </ion-button>
    <ion-button 
      (click)="share('share', $event)"
      [class.faded]="!listing.webPublished"
      size="small"
      fill="clear"
    >
      <ion-icon class="cpy-lnk mob-cpy pc-lnk" name="share-social-outline"></ion-icon>
    </ion-button>
    <ion-button
      (click)="openSlugLink(listing,$event)"
      [class.faded]="!listing.webPublished"
      size="small"
      fill="clear"
    >
      <ion-icon class="cpy-lnk mob-cpy pc-lnk" name="link-outline"></ion-icon>
    </ion-button>
    <ion-button
      *ngIf="!listing.sampleListing && userRole == 'agentAdmin'" 
      (click)="openListingScheduling(listing, $event)"
      [class.disabled-btn]="listing?.listingDetails?.saleStatus === 'inactive'"
      size="small"
      fill="clear"
    >
      <ion-icon class="cpy-lnk mob-cpy pc-lnk" name="calendar-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="listing-controls">
    <ion-button class="pc-lnk" size="small" fill="clear" (click)="presentPopover('desktop', $event)"
      [attr.data-cy]="'listingItem-' + listing.address.title + '-editBtn'" ion-button>
      <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
    </ion-button>

    <ion-button class="mobile-lnk" size="small" fill="clear" (click)="presentPopover('mobile', $event)"
      [attr.data-cy]="'listingItem-' + listing.address.title + '-editBtn'">
      <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
    </ion-button>

    <!--
<div (click)="goToOpenHouseMode($event)" class="button button-md">Launch
  </div>
  -->

    <div class="footer" (click)="goToMyGuests(listing.id)"></div>
  </div>
</div>

<!-- <ion-footer class="mob-link">
  <ion-button  ion-button (click)="share('share',listing)"   ><ion-icon class="cpy-lnk mob-cpy"  src='assets/imgs/share-icon.svg'></ion-icon></ion-button>
  <ion-button  ion-button (click)="openSlugLink(listing)" ><ion-icon class="cpy-lnk mob-cpy"  src='assets/imgs/link-icon.svg'></ion-icon></ion-button>
</ion-footer> -->

<div class="skeletonContainer" *ngIf="!loaded">

  <ion-skeleton-text animated style="height:100px; width:136px;"></ion-skeleton-text>

  <div class="skeletonSub">

    <ion-skeleton-text animated style="height:12px; width:90%"></ion-skeleton-text>
    <ion-skeleton-text animated style="height:12px; width:80%"></ion-skeleton-text>
    <ion-skeleton-text animated style="height:12px; width:60%"></ion-skeleton-text>
  </div>

</div>